module.exports = Plotly;


//////////////////
// WEBPACK FOOTER
// external "Plotly"
// module id = 128
// module chunks = 1